import { graphql } from "@/lib/generated"

export const EventReceivedSubscription = graphql(`
  subscription EventReceived($sourceId: UUID, $sourceSlug: String) {
    eventReceived(sourceId: $sourceId, sourceSlug: $sourceSlug) {
      id
      sourceId
      idempotencyKey
      eventType
      status
      receivedAt
      source {
        id
        name
        slug
      }
    }
  }
`)

export const DeliveryUpdatedSubscription = graphql(`
  subscription DeliveryUpdated($destinationId: UUID, $eventId: UUID) {
    deliveryUpdated(destinationId: $destinationId, eventId: $eventId) {
      id
      eventId
      subscriptionId
      destinationId
      status
      attempts
      maxAttempts
      nextAttemptAt
      createdAt
      destination {
        id
        name
        url
      }
    }
  }
`)

export const DLQEntryCreatedSubscription = graphql(`
  subscription DLQEntryCreated {
    dlqEntryCreated {
      id
      deliveryId
      eventId
      lastError
      createdAt
      event {
        id
        eventType
        sourceId
      }
      delivery {
        id
        destinationId
        destination {
          id
          name
          url
        }
      }
    }
  }
`)

export const SourceChangedSubscription = graphql(`
  subscription SourceChanged {
    sourceChanged {
      id
      name
      slug
      providerType
      status
    }
  }
`)

export const DestinationChangedSubscription = graphql(`
  subscription DestinationChanged {
    destinationChanged {
      id
      name
      url
      status
    }
  }
`)

export const SubscriptionChangedSubscription = graphql(`
  subscription SubscriptionChanged {
    subscriptionChanged {
      id
      name
      sourceId
      destinationId
      enabled
    }
  }
`)
